"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightContext = void 0;
exports.default = HighlightProvider;
exports.useHighlight = useHighlight;
var _react = _interopRequireWildcard(require("react"));
var _Highlight = _interopRequireWildcard(require("../reducers/Highlight"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var HighlightContext = exports.HighlightContext = /*#__PURE__*/(0, _react.createContext)();
function HighlightProvider(_ref) {
  var {
    children
  } = _ref;
  var [highlights, dispatch] = (0, _react.useReducer)(_Highlight.default, []);
  var [focus, setFocus] = (0, _react.useState)();
  return /*#__PURE__*/_react.default.createElement(HighlightContext.Provider, {
    value: {
      highlights,
      dispatch,
      ACTION: _Highlight.ACTION,
      focus,
      setFocus
    }
  }, children);
}
function useHighlight() {
  return (0, _react.useContext)(HighlightContext);
}